var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeViewWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8701 11.4999C21.2301 10.3899 17.7101 4.81987 11.7301 4.99987C6.20007 5.13987 3.00007 9.99987 2.13007 11.4999C1.95144 11.8093 1.95144 12.1905 2.13007 12.4999C2.76007 13.5899 6.13007 18.9999 12.0201 18.9999H12.2701C17.8001 18.8599 21.0101 13.9999 21.8701 12.4999C22.0487 12.1905 22.0487 11.8093 21.8701 11.4999ZM12.0001 15.4999C10.0671 15.4999 8.50007 13.9329 8.50007 11.9999C8.50007 10.0669 10.0671 8.49987 12.0001 8.49987C13.9331 8.49987 15.5001 10.0669 15.5001 11.9999C15.5001 13.9329 13.9331 15.4999 12.0001 15.4999ZM12.0001 13.4999C12.8285 13.4999 13.5001 12.8283 13.5001 11.9999C13.5001 11.1714 12.8285 10.4999 12.0001 10.4999C11.1716 10.4999 10.5001 11.1714 10.5001 11.9999C10.5001 12.8283 11.1716 13.4999 12.0001 13.4999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeViewWhite);
export default __webpack_public_path__ + "static/media/eyeViewWhite.90bf809c9a02a49e98636dde93137f24.svg";
export { ForwardRef as ReactComponent };